module.exports = __webpack_public_path__ + "img/auPlat-off.994e4d30.svg";